import { Box, DrawerBody, DrawerHeader, Button, Flex, IconButton, Icon } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconClose } from 'assets/icons';
import { DrawerFixedButton } from 'components/Drawer';
import { FormikInput } from 'components/Formik';
import { useAddBillingEmail } from 'hooks/accountBilling/useAddBillingEmail';

import { billingEmailValidationSchema, initialBillingEmail } from './schema';

interface IChangeBillingEmail {
  onClose: () => void;
  currentBillingEmail?: string;
}

const ChangeBillingEmail: React.FC<IChangeBillingEmail> = ({ onClose, currentBillingEmail }) => {
  const { t } = useTranslation(['common', 'accountBilling']);

  const { status, mutateAsync } = useAddBillingEmail();

  const handleFormSubmit = (values: typeof initialBillingEmail) => {
    const postData = {
      email: values.email,
    };

    mutateAsync(postData).then(() => {
      if (onClose) {
        onClose();
      }
    });
  };

  return (
    <Box h="100%">
      <DrawerHeader>
        <Flex justifyContent="space-between" alignItems="center">
          {t('accountBilling:changeBillingEmail')}
          <IconButton
            aria-label="Close"
            icon={<Icon as={IconClose} height="15px" width="15px" />}
            onClick={onClose}
            variant="unstyled"
          />
        </Flex>
      </DrawerHeader>
      <DrawerBody h="100%">
        <Formik
          enableReinitialize
          initialValues={initialBillingEmail}
          validationSchema={billingEmailValidationSchema}
          onSubmit={handleFormSubmit}
        >
          {() => (
            <Form noValidate>
              <FormikInput
                type="email"
                name="email"
                label={t('accountBilling:billingEmailAddress')}
                inputProps={{
                  placeholder: currentBillingEmail || t('accountBilling:billingEmailAddress'),
                }}
                formControlProps={{
                  isRequired: true,
                }}
              />
              <DrawerFixedButton>
                <Flex alignItems="center" justifyContent="flex-end" gridGap={4}>
                  <Button variant="ghost" colorScheme="secondary" onClick={onClose}>
                    {t('common:cancel')}
                  </Button>
                  <Button colorScheme="secondary" type="submit" isLoading={status === 'loading'}>
                    {t('accountBilling:addBillingEmail')}
                  </Button>
                </Flex>
              </DrawerFixedButton>
            </Form>
          )}
        </Formik>
      </DrawerBody>
    </Box>
  );
};

export default ChangeBillingEmail;
